export const TAG_TYPE = {
  COMPETITION: 'competition',
  DISCIPLINE: 'discipline',
  ATHLETE: 'competitor',
  EVENT: 'event',
};

export const FILTER_OPTION = {
  ALL: {
    key: '',
    label: 'All types',
  },
  COMPETITION: {
    key: TAG_TYPE.COMPETITION,
    label: 'Competition',
  },
  DISCIPLINE: {
    key: TAG_TYPE.DISCIPLINE,
    label: 'Discipline',
  },
  ATHLETE: {
    key: TAG_TYPE.ATHLETE,
    label: 'Athlete',
  },
};
export const FILTER_OPTIONS = Object.values(FILTER_OPTION);
